import styled from 'styled-components';

export const MobileAppAuthPinDescriptionStyled = styled.p`
    margin-top: 12px;
    margin-bottom: 0;
    font-size: 16px;
    min-height: 24px;
`;

export const MobileAppAuthPinNumbersPanelStyled = styled.div`
    margin-bottom: 40px;
    button {
        width: 72px;
        height: 72px;
        font-size: 32px;
        margin: 8px;
        border: none;
        
        &:hover, &:focus {
            background-color: unset;
        }
        &:active {
            background-color: var(--color-purple);
            color: var(--color-white);
        }
    }
`;

export const MobileAppAuthPinDotsContainerStyled = styled.div`
    display: flex;
    margin-top: 40px;
`;

export const MobileAppAuthPinDotStyled = styled.div`
    width: 16px;
    height: 16px;
    margin: 2px 14px;
    border-radius: 10px;
    background-color: var(--color-secondary);
    
    &.selected {
        background-color: var(--color-yellow);
    }
    &.positive {
        background-color: var(--color-green-secondary);
    }
    &.negative {
        background-color: var(--color-negative-secondary);
    }
    
    &.increased {
        width: 20px;
        height: 20px;
        margin: 0 12px;
    }
`;
